"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SmartEncodingMap = {
    '\u00ab': '"',
    '\u00bb': '"',
    '\u201c': '"',
    '\u201d': '"',
    '\u02ba': '"',
    '\u02ee': '"',
    '\u201f': '"',
    '\u275d': '"',
    '\u275e': '"',
    '\u301d': '"',
    '\u301e': '"',
    '\uff02': '"',
    '\u2018': "'",
    '\u2019': "'",
    '\u02BB': "'",
    '\u02c8': "'",
    '\u02bc': "'",
    '\u02bd': "'",
    '\u02b9': "'",
    '\u201b': "'",
    '\uff07': "'",
    '\u00b4': "'",
    '\u02ca': "'",
    '\u0060': "'",
    '\u02cb': "'",
    '\u275b': "'",
    '\u275c': "'",
    '\u0313': "'",
    '\u0314': "'",
    '\ufe10': "'",
    '\ufe11': "'",
    '\u00F7': '/',
    '\u00bc': '1/4',
    '\u00bd': '1/2',
    '\u00be': '3/4',
    '\u29f8': '/',
    '\u0337': '/',
    '\u0338': '/',
    '\u2044': '/',
    '\u2215': '/',
    '\uff0f': '/',
    '\u29f9': '\\',
    '\u29f5': '\\',
    '\u20e5': '\\',
    '\ufe68': '\\',
    '\uff3c': '\\',
    '\u0332': '_',
    '\uff3f': '_',
    '\u20d2': '|',
    '\u20d3': '|',
    '\u2223': '|',
    '\uff5c': '|',
    '\u23b8': '|',
    '\u23b9': '|',
    '\u23d0': '|',
    '\u239c': '|',
    '\u239f': '|',
    '\u23bc': '-',
    '\u23bd': '-',
    '\u2015': '-',
    '\ufe63': '-',
    '\uff0d': '-',
    '\u2010': '-',
    '\u2043': '-',
    '\ufe6b': '@',
    '\uff20': '@',
    '\ufe69': '$',
    '\uff04': '$',
    '\u01c3': '!',
    '\ufe15': '!',
    '\ufe57': '!',
    '\uff01': '!',
    '\ufe5f': '#',
    '\uff03': '#',
    '\ufe6a': '%',
    '\uff05': '%',
    '\ufe60': '&',
    '\uff06': '&',
    '\u201a': ',',
    '\u0326': ',',
    '\ufe50': ',',
    '\ufe51': ',',
    '\uff0c': ',',
    '\uff64': ',',
    '\u2768': '(',
    '\u276a': '(',
    '\ufe59': '(',
    '\uff08': '(',
    '\u27ee': '(',
    '\u2985': '(',
    '\u2769': ')',
    '\u276b': ')',
    '\ufe5a': ')',
    '\uff09': ')',
    '\u27ef': ')',
    '\u2986': ')',
    '\u204e': '*',
    '\u2217': '*',
    '\u229B': '*',
    '\u2722': '*',
    '\u2723': '*',
    '\u2724': '*',
    '\u2725': '*',
    '\u2731': '*',
    '\u2732': '*',
    '\u2733': '*',
    '\u273a': '*',
    '\u273b': '*',
    '\u273c': '*',
    '\u273d': '*',
    '\u2743': '*',
    '\u2749': '*',
    '\u274a': '*',
    '\u274b': '*',
    '\u29c6': '*',
    '\ufe61': '*',
    '\uff0a': '*',
    '\u02d6': '+',
    '\ufe62': '+',
    '\uff0b': '+',
    '\u3002': '.',
    '\ufe52': '.',
    '\uff0e': '.',
    '\uff61': '.',
    '\uff10': '0',
    '\uff11': '1',
    '\uff12': '2',
    '\uff13': '3',
    '\uff14': '4',
    '\uff15': '5',
    '\uff16': '6',
    '\uff17': '7',
    '\uff18': '8',
    '\uff19': '9',
    '\u02d0': ':',
    '\u02f8': ':',
    '\u2982': ':',
    '\ua789': ':',
    '\ufe13': ':',
    '\uff1a': ':',
    '\u204f': ';',
    '\ufe14': ';',
    '\ufe54': ';',
    '\uff1b': ';',
    '\ufe64': '<',
    '\uff1c': '<',
    '\u0347': '=',
    '\ua78a': '=',
    '\ufe66': '=',
    '\uff1d': '=',
    '\ufe65': '>',
    '\uff1e': '>',
    '\ufe16': '?',
    '\ufe56': '?',
    '\uff1f': '?',
    '\uff21': 'A',
    '\u1d00': 'A',
    '\uff22': 'B',
    '\u0299': 'B',
    '\uff23': 'C',
    '\u1d04': 'C',
    '\uff24': 'D',
    '\u1d05': 'D',
    '\uff25': 'E',
    '\u1d07': 'E',
    '\uff26': 'F',
    '\ua730': 'F',
    '\uff27': 'G',
    '\u0262': 'G',
    '\uff28': 'H',
    '\u029c': 'H',
    '\uff29': 'I',
    '\u026a': 'I',
    '\uff2a': 'J',
    '\u1d0a': 'J',
    '\uff2b': 'K',
    '\u1d0b': 'K',
    '\uff2c': 'L',
    '\u029f': 'L',
    '\uff2d': 'M',
    '\u1d0d': 'M',
    '\uff2e': 'N',
    '\u0274': 'N',
    '\uff2f': 'O',
    '\u1d0f': 'O',
    '\uff30': 'P',
    '\u1d18': 'P',
    '\uff31': 'Q',
    '\uff32': 'R',
    '\u0280': 'R',
    '\uff33': 'S',
    '\ua731': 'S',
    '\uff34': 'T',
    '\u1d1b': 'T',
    '\uff35': 'U',
    '\u1d1c': 'U',
    '\uff36': 'V',
    '\u1d20': 'V',
    '\uff37': 'W',
    '\u1d21': 'W',
    '\uff38': 'X',
    '\uff39': 'Y',
    '\u028f': 'Y',
    '\uff3a': 'Z',
    '\u1d22': 'Z',
    '\u02c6': '^',
    '\u0302': '^',
    '\uff3e': '^',
    '\u1dcd': '^',
    '\u2774': '{',
    '\ufe5b': '{',
    '\uff5b': '{',
    '\u2775': '}',
    '\ufe5c': '}',
    '\uff5d': '}',
    '\uff3b': '[',
    '\uff3d': ']',
    '\u02dc': '~',
    '\u02f7': '~',
    '\u0303': '~',
    '\u0330': '~',
    '\u0334': '~',
    '\u223c': '~',
    '\uff5e': '~',
    '\u00a0': '  ',
    '\u2000': '  ',
    '\u2002': '  ',
    '\u2003': '  ',
    '\u2004': '  ',
    '\u2005': '  ',
    '\u2006': '  ',
    '\u2007': '  ',
    '\u2008': '  ',
    '\u2009': '  ',
    '\u200a': '  ',
    '\u202f': '  ',
    '\u205f': '  ',
    '\u3000': '  ',
    '\u008d': '  ',
    '\u009f': '  ',
    '\u0080': '  ',
    '\u0090': '  ',
    '\u009b': '  ',
    '\u0010': '',
    '\u0009': '       ',
    '\u0000': '',
    '\u0003': '',
    '\u0004': '',
    '\u0017': '',
    '\u0019': '',
    '\u0011': '',
    '\u0012': '',
    '\u0013': '',
    '\u0014': '',
    '\u2060': '',
    '\u2017': "'",
    '\u2014': '-',
    '\u2013': '-',
    '\u2039': '>',
    '\u203A': '<',
    '\u203C': '!!',
    '\u201E': '"',
    '\u2028': ' ',
    '\u2029': ' ',
    '\u2026': '...',
    '\u2001': ' ',
    '\u200b': '',
    '\u3001': ',',
    '\uFEFF': '',
    '\u2022': '-', // Bullet
};
exports.default = SmartEncodingMap;
//# sourceMappingURL=SmartEncodingMap.js.map